/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsArrowsMaximize: {
  name: 'arrows-maximize';
  data: string;
} = {
  name: 'arrows-maximize',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M5 4a1 1 0 0 0-1 1v5a1 1 0 0 0 2 0V7.414l3.293 3.293a1 1 0 0 0 1.414-1.414L7.414 6H10a1 1 0 1 0 0-2H5Zm9 0a1 1 0 1 0 0 2h2.586l-3.293 3.293a1 1 0 1 0 1.414 1.414L18 7.414V10a1 1 0 1 0 2 0V5a1 1 0 0 0-1-1h-5Zm-3.293 9.293a1 1 0 0 1 0 1.414L7.414 18H10a1 1 0 1 1 0 2H5a1 1 0 0 1-1-1v-5a1 1 0 0 1 2 0v2.586l3.293-3.293a1 1 0 0 1 1.414 0Zm4 0a1 1 0 0 0-1.414 1.414L16.586 18H14a1 1 0 1 0 0 2h5a1 1 0 0 0 1-1v-5a1 1 0 0 0-2 0v2.586l-3.293-3.293Z" fill="currentColor"/></svg>`,
};
